module.exports = __webpack_public_path__ + "static/media/star.306aebec.svg";